import React, { memo } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import {
  cellValueIconStyles,
  cellValueTextStyles,
  cellValueWrapperStyles,
} from './SlaGroupInfoModal.styles';

const TaskSlaLevelCell = ({ level }) => {
  const { assignmentType, assignmentTypeInfo } = level;

  if (!assignmentTypeInfo) {
    return <Typography variant="regular16">{assignmentType}</Typography>;
  }

  return (
    <Box sx={cellValueWrapperStyles}>
      <Typography sx={cellValueTextStyles} variant="regular16">
        {assignmentType}
      </Typography>
      <Tooltip placement="top" title={assignmentTypeInfo}>
        <Box sx={cellValueIconStyles}>
          <InfoIcon />
        </Box>
      </Tooltip>
    </Box>
  );
};

TaskSlaLevelCell.propTypes = {
  level: PropTypes.object.isRequired,
};

export default memo(TaskSlaLevelCell);
